// eslint-disable-next-line react-hooks/exhaustive-deps
import { Grid } from "@mui/material";
import Stack from "@mui/material/Stack";
import { setInnCode } from "components/app/App.slice";
import ThemeContext from "components/app/Context";
import Feedback from "components/common/Feedback";
import Typography from "components/common/Typography";
import InncodeDropDown from "components/common/dropdowns/InncodeDropDown";
import { clearDashboardData, fetchDashboardReportAsync } from "components/features/dashboard/Dashboard.slice";
import SuggestedPlans from "components/features/dashboard/SuggestedPlans";
import { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import { tokens } from "styles/Tokens";
import { missingIncodeText } from "utils/CommonConstants";
import { fetchExternalUserDetails } from "../InncodeUsers/userdashboard.slice";
import {
  fetchSuggestedPlansAsync,
  fetchSuggestedPlansIdAsync,
  setSuggestedPlanList
} from "../library/Suggested/Suggested.slice";
import MyDashboard from "./MyDashboard";

function Index() {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [searchParams, setSearchParams] = useSearchParams();
  const { isMobileScreen } = useContext(ThemeContext);
  const { isAbovePropertyUser, isAdmin } = useAppSelector((state) => state.app);
  let innCode = useAppSelector((state: any) => state.app.innCode);
  const [planTypesCmsIds, setPlanTypesCmsIds] = useState<string[]>([]);
  const suggestedPlanIds: any = useAppSelector((state) => state.suggestedPlans.listIds);
  const externalHltId = searchParams.get("member");
  const selectedInncode = searchParams.get("inncode");
  const { externalUserDetails, innCodeDetails }: any = useAppSelector((state) => state.userDashboard);
  innCode = selectedInncode ?? innCode;

  const getDashboardReports = () => {
    dispatch(clearDashboardData());

    if (innCode && innCode !== missingIncodeText) {
      dispatch(
        fetchDashboardReportAsync({
          innCode,
          externalHltId,
          list: "TOTAL_PLANS,PLANS_SNAPSHOT,CARDS_SNAPSHOT"
        })
      );
    }

    dispatch(fetchSuggestedPlansIdAsync({ innCode, externalHltId, getTopSuggested: false }));
  };

  useEffect(() => {
    getDashboardReports();
  }, [innCode]);

  useEffect(() => {
    if (suggestedPlanIds?.length > 0) {
      const cmsIds = suggestedPlanIds
        ?.filter(
          (item: any) =>
            item?.breadCrumbPlanType === "recommended_criteria" || item?.breadCrumbPlanType === "recommended_default"
        )
        .map((i: any) => i?.cmsId);

      if (cmsIds.length > 0) {
        setPlanTypesCmsIds(cmsIds);
      } else {
        dispatch(setSuggestedPlanList());
      }

      return;
    }
  }, [suggestedPlanIds]);

  useEffect(() => {
    if (planTypesCmsIds?.length > 0) {
      const getSuggestedPlans = async () => {
        const props: any = {
          externalHltId,
          filter: {
            innCode,
            ids: planTypesCmsIds
          },
          pagination: {
            page: 1,
            size: 5
          },
          isSortingDisabled: true
        };
        await dispatch(fetchSuggestedPlansAsync(props));
      };
      getSuggestedPlans();
    }
  }, [planTypesCmsIds]);

  useEffect(() => {
    if (externalHltId) {
      dispatch(fetchExternalUserDetails({ hltIds: externalHltId }));
    }
  }, [externalHltId]);

  const handleOnChange = async (value: string) => {
    if (isAdmin || isAbovePropertyUser) {
      // getDashboardReports();
      dispatch(setInnCode(value));
      setSearchParams({ member: externalHltId ?? "", inncode: value });
    } else {
      dispatch(setInnCode(value));
      localStorage.setItem("innCode", value);
    }
  };

  return (
    <>
      <Feedback
        form=""
        actionStatus={{
          shouldShow: location?.state?.hasNoAccess,
          variant: location?.state?.variant ? location?.state?.variant : "error"
        }}
        message={location?.state?.message}
      />

      <Grid container>
        <Grid
          container
          item
          xs={12}
          md={8.5}
          sx={{
            marginY: "24px",
            display: "flex",
            flexDirection: "column"
          }}
        >
          {(isAdmin || isAbovePropertyUser) && (
            <Stack
              spacing={2}
              direction={isMobileScreen ? "column" : "row"}
              sx={{ my: "8px", mr: isMobileScreen ? 0 : "24px" }}
            >
              <Stack flex="1" spacing={2}>
                <Stack spacing={2} direction="row" alignItems="center">
                  <Typography variant="body2" color={tokens.Text.General.Secondary}>
                    Inncode Selected
                  </Typography>
                  <InncodeDropDown
                    backgroundColor={tokens.Background.General.Color}
                    width={isMobileScreen ? "170px" : "250px"}
                    color={tokens.Text.General.Color}
                    isAdmin={isAdmin || isAbovePropertyUser}
                    value={innCode}
                    onChange={handleOnChange}
                    externalOptions={innCodeDetails}
                    hideSearch
                  />
                </Stack>
                <Typography variant="h4" showBold color={tokens.Text.General.PrimaryBody}>
                  {externalUserDetails?.displayName}
                </Typography>
              </Stack>
            </Stack>
          )}
          {!isAdmin && !isAbovePropertyUser && (
            <Grid
              item
              sx={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center"
              }}
            >
              <Typography variant="body2" color={tokens.Text.General.Secondary} sx={{ marginRight: "8px" }}>
                Exploring plans for
              </Typography>
              <InncodeDropDown
                backgroundColor={tokens.Background.General.Color}
                width={isMobileScreen ? "170px" : "250px"}
                height="24px"
                color={tokens.Text.General.Color}
                isAdmin={isAdmin}
                value={innCode}
                onChange={handleOnChange}
              />
            </Grid>
          )}

          <MyDashboard />
        </Grid>
        <SuggestedPlans />
      </Grid>
    </>
  );
}

export default Index;
